import React from "react";
import { Button } from "@mui/material";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

import { Locale } from "../../../../../assets/Locale";

import "./EventSignOut.scss";

export const EventSignOut = ({ event, signPort })=>{
    const say = Locale.use();
    const locked = !event.isOpenToUsers || signPort.isStatus("pull", "push");
    

    return (
        <Button
            className="BlimpMuiPanel-action"
            disabled={locked}
            onClick={_=>signPort.act.signOut()}
            startIcon={<LogoutOutlinedIcon/>}
            type="button"
            variant="outlined"
        >
            {say("eventSignOutAction")}
        </Button>
    );
};